import { Cloudinary } from '@cloudinary/url-gen'
import { AdvancedImage, responsive } from '@cloudinary/react'
import React from 'react'

type Props = {
  imagePublicId: any
  imageAltText: string
  cloudName?: string
  // eslint-disable-next-line react/require-default-props
  onClick?: React.MouseEventHandler
  style?: React.CSSProperties
}

export const CloudinaryAdvancedImage: React.FC<Props> = ({
  imagePublicId,
  imageAltText,
  style,
  onClick,
  cloudName,
}) => {
  const myCld = new Cloudinary({
    cloud: {
      cloudName:
        process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME ||
        cloudName ||
        'resilia-dev',
    },
  })

  const img = myCld.image(imagePublicId)
  return (
    <AdvancedImage
      cldImg={img}
      style={style}
      alt={imageAltText}
      onClick={onClick}
      plugins={[responsive({ steps: [320, 600, 960, 1280] })]}
    />
  )
}
